import { WidgetProps } from '@rjsf/core';
import React, { useState } from 'react';
import OAuth from '@components/sources/source/cloudSource/cloudSourceAuth/Oauth';
import AuthAccounts from '@components/sources/source/cloudSource/cloudSourceAuth/authAccounts';
import { useFormData } from '../formContext';
import { get, last } from 'lodash';

interface OauthWidgetProps extends Partial<WidgetProps> {
  uiSchema: {
    'ui:options': {
      role: string;
      displayName: string;
      provider?: string;
      /*
        The path of the params inside the configuration
        that are needed for the oauth flow
        Example:
          paramsFromConfig = [["credentials", "is_sandbox"]]
          that refers to { credentials:{ is_sandbox: true } }
      */
      paramsFromConfig?: string[][];
    };
  };
}

const OauthWidget = (props: OauthWidgetProps) => {
  const { uiSchema, value, onChange, disabled } = props;
  const options = uiSchema!['ui:options'] || {};
  const { paramsFromConfig, role = '', displayName = '', provider } = options;
  const { formData } = useFormData();
  const sourceRole = role;
  let params = {} as Record<string, unknown>;
  if (paramsFromConfig) {
    // get the required params from the user input that exists in formData
    params = paramsFromConfig.reduce((occum, path) => {
      const key = last(path) as string;
      const val = get(formData, path);
      occum[key] = val;
      return occum;
    }, {} as Record<string, unknown>);
  }
  // null means that the information if accounts exist is unknown yet
  const [hasAccount, setHasAccount] = useState<boolean | null>(null);
  const [newAccount, setNewAccount] = useState<string>('');
  React.useEffect(() => {
    if (value) {
      onChange!(value);
    }
  }, []);
  return (
    <>
      <AuthAccounts
        disabled={disabled}
        key={newAccount}
        hasAccounts={(hasAccounts) => setHasAccount(hasAccounts)}
        selectedAccount={value}
        role={sourceRole}
        onClick={(val) => {
          // json-schema-form required fields need undefined value to determine that is not filled
          onChange!(val || undefined);
        }}
      />
      {hasAccount != null && !disabled && (
        <div data-testid="singer-Oauth">
          <OAuth
            params={{ role: sourceRole, ...params }}
            role={sourceRole}
            onComplete={(val) => {
              setNewAccount(val);
              onChange!(val);
            }}
            title={displayName as string}
            provider={provider as string}
          />
        </div>
      )}
    </>
  );
};

export default OauthWidget;
